import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import styled from 'styled-components';
import {
  ShowIcon,
  HiddenIcon,
  CloseCircle,
} from 'components/shared/DesignSystem/Icons';

// #region styled-components
const ErrorMessage = styled.span`
  font-size: 12px;
  color: #ef4e4e;
`;

const IconWrapper = styled.div`
  margin-right: 6px;
`;
// #endregion

const IconComponent = ({ type, size, color, onClick }) => {
  if (type === 'text') {
    return <ShowIcon size={size} color={color} onClick={onClick} />;
  }
  return <HiddenIcon size={size} color={color} onClick={onClick} />;
};

IconComponent.propTypes = { type: PropTypes.string, ...ShowIcon.propTypes };

const TextInputField = ({
  placeholder,
  name,
  type,
  addEyeIcon,
  showClearIcon,
  onChange,
  error,
  'aria-describedby': ariaDescribedBy,
}) => {
  const [currentType, setCurrentType] = useState(type);
  const toggleText = () =>
    setCurrentType((prev) => (prev === type ? 'text' : type));
  const [focused, setFocused] = useState(false);
  return (
    <div className="form-field padding-s">
      <Field name={name}>
        {({ meta, field, form }) => (
          <div className="input-wrap input-wrap--withicon">
            <div style={{ flex: 1 }}>
              <input
                placeholder={meta.touched ? null : placeholder}
                type={currentType}
                onFocus={() => setFocused(true)}
                {...field}
                onBlur={() => {
                  form.setFieldTouched(name, true);
                  setTimeout(() => setFocused(false), 500);
                  field.onBlur(name);
                }}
                onChange={(evt) => {
                  if (onChange) onChange(evt);
                  field.onChange(evt);
                }}
                data-testid={`signup__${name}`}
                aria-describedby={ariaDescribedBy}
              />
              <label>
                {meta.touched && (meta.error || error) ? (
                  <ErrorMessage>{meta.error || error}</ErrorMessage>
                ) : (
                  placeholder
                )}
              </label>
            </div>
            <IconWrapper>
              {addEyeIcon ? (
                <IconComponent
                  type={currentType}
                  size={20}
                  color="#707B86"
                  onClick={toggleText}
                />
              ) : null}
              {field.value && focused && showClearIcon ? (
                <CloseCircle
                  size={20}
                  color="#707B86"
                  onClick={() => {
                    form.setFieldTouched(name, false);
                    form.setFieldValue(name, '', false);
                  }}
                />
              ) : null}
            </IconWrapper>
          </div>
        )}
      </Field>
    </div>
  );
};

TextInputField.propTypes = {
  placeholder: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  addEyeIcon: PropTypes.bool,
  showClearIcon: PropTypes.bool,
  onChange: PropTypes.func,
  error: PropTypes.string,
  'aria-describedby': PropTypes.string,
};

export default TextInputField;
